import type { PriceRankItem, PriceRankItemInput } from "@/lib/gql/__generated__/graphql";

import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

import type { RoomPriceRankItemType } from "../../type";

type Props = {
	onSetRoomPriceRankItem: (index: number) => (value: RoomPriceRankItemType) => void;

	onSetSelectedPriceRank: (input: PriceRankItem) => void;
};

export const useRoomPrice = ({
	onSetRoomPriceRankItem,
	onSetSelectedPriceRank: _onSetSelectedPriceRank, //
}: Props) => {
	const onSetPriceAmount =
		(idx: number, priceRankItem: RoomPriceRankItemType) =>
		(roomID: string, amount: number | undefined, adultNum: number) => {
			const newPriceRankItem = {
				...priceRankItem,
				rooms: {
					isEdited: true,
					hasError: false,
					value: priceRankItem.rooms?.value?.map((item) => {
						if (item.roomID.value === roomID) {
							return {
								...item,
								prices: {
									isEdited: true,
									hasError: false,
									value: item.prices?.value?.map((price) => {
										if (price.adultNum.value === adultNum) {
											return {
												...price,
												price: {
													amount: {
														...price.price.amount,
														value: amount!,
													},
													currencyType: {
														...price.price.currencyType,
													},
												},
											};
										} else {
											return price;
										}
									}),
								},
							};
						} else {
							return item;
						}
					}),
				},
			} satisfies ForAutoGenerator<PriceRankItemInput, "">;

			onSetRoomPriceRankItem(idx)(newPriceRankItem);
		};

	return {
		onSetPriceAmount,
	};
};
